import React from 'react';
import IndexPage from '../src/pages/index';

const Page = function () {
  return <IndexPage />;
};

export default Page;
